/**
 * Redux form Selectors
 */

import { get } from 'lodash';
import { getFormValues } from 'redux-form';

import { CheckoutStepBillingFormFields } from '../../components/pages/Checkout/CheckoutStepBilling';
import { CheckoutStepLicenseFormFields } from '../../components/pages/Checkout/CheckoutStepLicense';
import { CheckoutStepFormName, DefaultBillingAddressIsSameAsLicensee } from '../../components/pages/Checkout/config';

export const getForm = <T = any>(formName: string) =>
  (state: IStoreState) => getFormValues<T, IStoreState>(formName)(state);

export const getBillingAddress = (state: IStoreState) => {
  const licenseInformation = getForm<CheckoutStepLicenseFormFields>(CheckoutStepFormName.license)(state);
  const billingInformation = getForm<CheckoutStepBillingFormFields>(CheckoutStepFormName.billing)(state);
  const address = get<CheckoutStepLicenseFormFields, 'address'>(licenseInformation, 'address');
  // tslint:disable-next-line:max-line-length
  const sameAddressAsLicensee = get<CheckoutStepBillingFormFields, 'sameAddressAsLicensee', boolean>(billingInformation, 'sameAddressAsLicensee', DefaultBillingAddressIsSameAsLicensee);
  return sameAddressAsLicensee ? address : get(billingInformation, 'address', address);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/form/selectors.ts